<template>
    <LoadingCard v-if="loading" />
    <div class="content__inner content__inner--md" v-else>
        <header class="content__title pl-0">
            <h1>Growers</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new Grower"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="toolbar">
            <div class="toolbar__search d-block">
                <input type="text" placeholder="Search..." v-model="searchTerm">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6" v-for="user in filteredUsers">
                <div class="card p-3">
                    <div class="row align-items-center">
                        <div class="col-1">
                            <Avatar class="user__img" :src="user.avatar" :size="39" backgroundColor="#61c365" :username="user.name" />
                        </div>
                        <div class="col-7">
                            <h5 class="mb-3">
                                {{ user.business_name }}
                                <small v-if="user.processor_number">{{ user.processor_number}}</small>
                            </h5>
                            <p class="mb-0 text-muted badge-group" v-if="user.is_processor_managed">
                                <span class="badge badge-light">Grower Status</span>
                                <span class="badge badge-alt-green">Managed</span>
                            </p>
                            <p class="mb-0 text-muted badge-group" v-else>
                                <span class="badge badge-light">Grower Status</span>
                                <span class="badge badge-primary">Individual</span>
                            </p>
                        </div>
                        <div class="col-4 text-right">
                            <b-btn class="btn--icon btn-danger" @click.prevent="promptUnlinkGrower(user.id)"
                                   v-b-tooltip="'Remove this relationship'">
                                <i class="zmdi zmdi-close"></i>
                            </b-btn>
                            <b-btn class="btn--icon btn-purple"
                                   @click.prevent="$root.startGhosting(user.id)"
                                   :to="{name: 'growers.orchard-maps.browse', params: {growerId: user.id}}"
                                   v-b-tooltip="'View orchard maps'">
                                <i class="zmdi zmdi-map"></i>
                            </b-btn>
                            <b-btn class="btn--icon btn-purple" v-if="user.is_processor_managed"
                                   @click.prevent="$root.startGhosting(user.id)"
                                   v-b-tooltip="'Login as grower'">
                                <i class="zmdi zmdi-accounts"></i>
                            </b-btn>
                            <b-btn class="btn--icon btn-warning"
                                   @click.prevent="showGrowSafeDialog(user)"
                                   v-b-tooltip="'View Growsafe certificates'">
                                <i class="zmdi zmdi-card-membership"></i>
                            </b-btn>
                            <router-link :to="{name: 'growers.blocks.browse', params: {growerId: user.id}}"
                                         class="btn btn--icon btn-light"
                                         v-b-tooltip="'View Blocks'">
                                <i class="zmdi zmdi-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <CreateModal :close="closeCreateDialog" @refresh="refetch" v-model="creating" v-if="creating" />
        <GrowSafeModal :close="closeGrowSafeDialog" @refresh="refetch" v-model="growSafe" v-if="growSafe" :user="user" />
    </div>
</template>
<script>
import listUsersQuery from '@views/Growers/ProcessorBrowse/queryListGrowers.graphql';
import deleteLinkMutation from '@views/Growers/ProcessorBrowse/mutationDeleteGrowerProcessorLink.graphql';

import Avatar from 'vue-avatar/src/Avatar';
import CreateModal from './CreateModal';
import GrowSafeModal from './GrowSafeModal';

export default {
  name: 'BrowseGrowers',
  apollo: {
    users: {
      query: listUsersQuery,
      update: data => data.filterProcessorGrowerLinkGrowers,
    },
  },
  components: {
    Avatar,
    CreateModal,
    GrowSafeModal,
  },
  computed: {
    filteredUsers() {
      if (this.searchTerm.length === 0) {
        return this.users;
      }
      return this.users.filter(user => user.business_name.includes(this.searchTerm));
    },
  },
  mounted() {
  },
  data() {
    return {
      users: [],
      user: null,
      searchTerm: '',
      loading: 0,
      creating: false,
      growSafe: false,
    };
  },
  methods: {
    refetch() {
      this.$apollo.queries.users.refetch();
    },
    promptUnlinkGrower(growerId) {
      const notification = this.$notifyConfirm('Are you sure you wish to remove this relationship?', {
        buttons: [
          this.$notification.button('Yes', 'btn btn-primary', () => {
            notification.close();
            this.doUnlinkGrower(growerId);
          }),
          this.$notification.button('Cancel', 'btn btn-light', () => notification.close()),
        ],
      });
    },
    doUnlinkGrower(growerId) {
      this.$apollo.mutate({
        mutation: deleteLinkMutation,
        variables: {
          input: {
            grower_id: growerId,
          },
        }
      }).then(this.refetch);
    },
    showGrowSafeDialog(user) {
      this.user = user;
      this.growSafe = true;
    },
    closeGrowSafeDialog() {
      this.growSafe = false;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
};
</script>
